import React from 'react';

export const BoutonFaireUneSimu: React.FC = () => {
  return (
    <div className="refaireSimu">
      <button
        className="boutonSize2"
        onClick={() => {
          window.location.assign("http://raf-prag.com/iframe")
          // window.location.assign("http://simubac2020.fr")
        }}
      >
        Refaire une simulation
      </button>
    </div>
  );
}